var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDrag = function SvgIconDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-drag_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-drag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M7.496 16c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 6 14.496c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 7.504 13c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059A1.456 1.456 0 0 1 7.496 16Zm5 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 11 14.496c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 12.504 13c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Zm-5-4.5c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 6 9.996c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 7.504 8.5c.414 0 .767.147 1.059.442.291.295.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Zm5 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 11 9.996c0-.414.147-.767.442-1.059a1.456 1.456 0 0 1 1.062-.437c.414 0 .767.147 1.059.442.291.295.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Zm-5-4.5c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 6 5.496c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 7.504 4c.414 0 .767.147 1.059.442.291.295.437.649.437 1.062 0 .414-.147.767-.442 1.059A1.456 1.456 0 0 1 7.496 7Zm5 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 11 5.496c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 12.504 4c.414 0 .767.147 1.059.442.291.295.437.649.437 1.062 0 .414-.147.767-.442 1.059A1.456 1.456 0 0 1 12.496 7Z"
  }))));
};
export default SvgIconDrag;